import valueFilters from '../valueFilters';
import validator from '../validator';
import enums from '../enum';
export interface IChangeTrackable {
	action?: 0 | 1;
	changeOrderKey?: string;
	isChange: boolean;
	isAddition: boolean;
	isModification: boolean;
	isDeletion: boolean;
	rootKey?: string;
	rowKey?: string;
}

export default {
	action: {
		setFilters: valueFilters.toNumber,
		defaultValue: () => enums.trackableActions.Set,
		rules: validator.enum('trackableActions', false) // allow "Set"/0
	},
	changeOrderKey: {
	},
	isChange: {
		writable: false,
		nonSerialized: true
	},
	_get_isChange: function () {
		return !!this.changeOrderKey;
	},
	isAddition: {
		writable: false,
		nonSerialized: true
	},
	_get_isAddition: function () {
		return this.isChange && this.action === enums.trackableActions.Set && (!this.rootKey || this.rootKey === this.key);
	},
	isModification: {
		writable: false,
		nonSerialized: true
	},
	_get_isModification: function () {
		return this.isChange && this.action === enums.trackableActions.Set && !!this.rootKey && this.rootKey !== this.key;
	},
	isDeletion: {
		writable: false,
		nonSerialized: true
	},
	_get_isDeletion: function () {
		return this.isChange && this.action === enums.trackableActions.Unset && this.rootKey !== this.key;
	},
	rootKey: {
	},
	rowKey: {
		writable: false,
		nonSerialized: true
	},
	_get_rowKey: function () {
		return this.rootKey || this.key;
	}
};